import React, { useState } from "react";
import { tokens } from "../../theme/theme";
import { Divider, Typography, Card, CardContent, Grid, CardHeader, IconButton, Button, useTheme, Box, Badge, } from "@mui/material";
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ArticleIcon from '@mui/icons-material/Article';
import UploadFileIcon from '@mui/icons-material/UploadFile';

import { useTranslation } from "react-i18next";
import DashboardCard from "../../components/common/DashboardCard";

const OrderManagementMenu = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();
    const [xlValue, setXLValue] = useState(2);

    const callback = () => {
        handleBackDashboard();
    };   

    return (
        <Box >

            <Card sx={{ backgroundColor: "transparent", borderRadius: "0px", height: "48px" }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h5" color={colors.grey[100]} fontWeight="bold" justifyContent="center">{t('order_management.order_management')} </Typography>
                    </Box>
                </CardContent>
            </Card>


            {/* <Divider /> */}
            <Box p={2}>
                <Grid container spacing={2} justifyContent="start" marginTop="10px"  >

                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('order_management.order_management')}
                            icon={<BookmarkBorderIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("Order Management")}
                            subtitle="Update"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('order_management.confirmation_order_to_dm')}
                            icon={<TrendingFlatIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("ConfirmationOrder")}
                            subtitle="Update"
                        />
                    </Grid>


                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('order_management.price_list')}
                            icon={<LocalOfferIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("PriceList")}
                            subtitle="View"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('order_management.hsn_master')}
                            icon={<ArticleIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("HSNMaster")}
                            subtitle="View"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('order_management.bulk_order_upload')}
                            icon={<UploadFileIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("BulkOrderUpload")}
                            subtitle="View"
                        />
                    </Grid>


                </Grid>
            </Box>
        </Box>

    )
}
export default OrderManagementMenu;